import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';

import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-add-merchantstorelist',
  templateUrl: './add-merchantstorelist.component.html',
  styleUrls: ['./add-merchantstorelist.component.scss']
})

export class AddmerchantstorelistComponent implements OnInit {
  currentDate = new Date();
  loadingspinner: boolean = false;
  submitted = false;
  xImage: any;

  currentUser: any;
  public CountryFilterCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();
  countryList: any;
 
  merchantstorelist: any;
  xstoreName: any;

  constructor(private fb: FormBuilder, private toastr: ToastrService, private tokenStorageService: TokenStorageService, public dialog: MatDialog,
    private authService: AuthService, public dialogRef: MatDialogRef<AddmerchantstorelistComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private modalService: NgbModal) {
  
  }


  ngOnInit() {

    //burkina faso :- orange :- mfs
    this.getmerchantstorelist();
    this.currentUser = this.tokenStorageService.getUser();

    // listen for search field value changes
    this.getCountryCode();

  }


  getCountryCode() {

    this.submitted = true;
    this.authService.getOtpIsdCode().subscribe((response: { isSuccess: any; result: any; Message: any; }) => {

      this.countryList = response;

    }, (err: any) => {
      this.toastr.error(err.error, 'Error');
    }
    );
  }
  openVerticallyCentered(content: any, id: any, storeName: any) {
    this.xImage = id;
    this.xstoreName = storeName;
    this.modalService.open(content, { centered: true, size: 'lg' });
  }
  filterCountry() {

    if (this.CountryFilterCtrl.value) {

      return this.countryList.filter((x: { name: string; }) => x.name.toLowerCase().startsWith(this.CountryFilterCtrl.value.toLowerCase()));
    } else {
      return this.countryList;
    }
  }
  
  

  getmerchantstorelist() {

    this.authService.getmerchantstorelist().subscribe(response => {
      if (response.apiStatus == true) {
        this.merchantstorelist = response.apiData;
      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }
}

